import React, { useEffect } from "react";
import { baseUrl, apiUrl } from "../../../config/apiConfig";
import axios from "axios";
import { useRouter } from "next/router";
import dynamic from "next/dynamic";
import CustomHead from "../../../components/common/head/Head";
import Custom404 from "../../_error";
import { translate } from "../../../helper/languageBasedData";
import { getTextContent, stringLimit } from "../../../helper/string";
import { metaSiteTitle } from "../../../config/defaultMetaConfig";
import RealatedBlogArea from "../../../components/common/blog/RelatedBlogArea";

const HeroArea = dynamic(
	() => import("../../../components/pages/service/HeroArea"),
	{
		loading: () => {
			return "";
		},
		ssr: false,
	}
);

const GoalArea = dynamic(
	() => import("../../../components/pages/service/GoalArea"),
	{
		loading: () => {
			return "";
		},
		ssr: false,
	}
);
const TechnologyArea = dynamic(
	() => import("../../../components/pages/service/TechnologyArea"),
	{
		loading: () => {
			return "";
		},
		ssr: false,
	}
);
const ProcessArea = dynamic(
	() => import("../../../components/pages/service/ProcessArea"),
	{
		loading: () => {
			return "";
		},
		ssr: false,
	}
);
const FaqArea = dynamic(
	() => import("../../../components/pages/service/FaqArea"),
	{
		loading: () => {
			return "";
		},
		ssr: false,
	}
);
const OtherServicesArea = dynamic(
	() => import("../../../components/pages/service/OtherServicesArea"),
	{
		loading: () => {
			return "";
		},
		ssr: false,
	}
);

const ContactUsArea = dynamic(
	() => import("../../../components/pages/homepage/ContactUsArea"),
	{
		loading: () => {
			return "";
		},
		ssr: false,
	}
);

const ServicePage = ({ serviceDetails, siteSetting }) => {
	// console.log("serviceDetails", serviceDetails);
	// console.log("siteSetting", siteSetting);

	const router = useRouter();

	useEffect(() => {
		let mounted = true;

		if (mounted) {
		}
		return () => {
			mounted = false;
		};
	}, [router, serviceDetails]);

	if (!serviceDetails) {
		return <Custom404 />;
	}

	return (
		<>
			<CustomHead
				title={
					(serviceDetails.serviceInfo && serviceDetails.serviceInfo.service_custom_title
						?serviceDetails.serviceInfo.service_custom_title 
						: translate(serviceDetails.serviceInfo.title)) +
					" | " +
					(siteSetting && siteSetting.title ? siteSetting.title : metaSiteTitle)
				}
				metaTitle={
					serviceDetails.serviceInfo && serviceDetails.serviceInfo.meta_title
						? serviceDetails.serviceInfo.meta_title
						: serviceDetails.serviceInfo.title
						? translate(serviceDetails.serviceInfo.title)
						: "Service Details"
				}
				description={
					serviceDetails.serviceInfo &&
					serviceDetails.serviceInfo.meta_description
						? serviceDetails.serviceInfo.meta_description
						: serviceDetails.serviceInfo.description
						? stringLimit(
								getTextContent(
									translate(serviceDetails.serviceInfo.description)
								)
						  )
						: ""
				}
				url={
					serviceDetails.serviceInfo && serviceDetails.serviceInfo.slug
						? baseUrl + "/service/" + serviceDetails.serviceInfo.slug
						: ""
				}
				keywords={
					serviceDetails.serviceInfo && serviceDetails.serviceInfo.meta_keyword
						? serviceDetails.serviceInfo.meta_keyword
						: null
				}
				image={
					serviceDetails.serviceInfo &&
					serviceDetails.serviceInfo.background_image
						? apiUrl + serviceDetails.serviceInfo.background_image
						: ""
				}
				type={"article"}
			/>
			<div className="page-area service-page-area mh-80v">
				<HeroArea serviceInfo={serviceDetails.serviceInfo} />
				{/* {serviceDetails &&
					serviceDetails.serviceInfo.service_goal_status == 1 && (
						<GoalArea serviceInfo={serviceDetails.serviceInfo} />
					)} */}
				{serviceDetails &&
					serviceDetails.serviceInfo.technology_status == 1 && (
						<TechnologyArea technologyInfo={serviceDetails.technologyData} />
					)}

				{serviceDetails &&
					serviceDetails.serviceInfo.processing_phase_status == 1 && (
						<ProcessArea
							servicesProcessingPhase={serviceDetails.servicesProcessingPhase}
							serviceInfo={serviceDetails.serviceInfo}
						/>
					)}
				{serviceDetails && serviceDetails.serviceInfo.faq_section == 1 && (
					<FaqArea servicesFaq={serviceDetails.servicesFaq} />
				)}
				<ContactUsArea siteSetting={siteSetting} />
				<OtherServicesArea relatedServices={serviceDetails.relatedServices} />
				<RealatedBlogArea />
			</div>
		</>
	);
};

export async function getServerSideProps(params) {
	try {
		const serviceDetails = await axios
			.get(apiUrl + "/api/serviceDetails?slug=" + params.query.slug)
			.then((response) => {
				return response.data.data;
			})
			.catch((error) => {
				return null;
			});
		const siteSetting = await axios
			.get(apiUrl + "/api/siteSetting")
			.then((response) => {
				return response.data.data;
			})
			.catch((error) => {
				return null;
			});

		return {
			props: {
				serviceDetails: serviceDetails,
				siteSetting: siteSetting,
				loaded: true,
			},
		};
	} catch (error) {
		return {
			props: {
				serviceDetails: null,
				siteSetting: null,
				loaded: true,
			},
		};
	}
}

export default ServicePage;
